var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('canvas',{ref:"myChart"}),_c('img',{ref:"ChartImg",staticStyle:{"display":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }